// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Createdatafactory/styles.css
// module id = 1912
// module chunks = 193